import { render, staticRenderFns } from "./depositComponent.vue?vue&type=template&id=496d43ae&"
import script from "./depositComponent.vue?vue&type=script&lang=js&"
export * from "./depositComponent.vue?vue&type=script&lang=js&"
import style0 from "./depositComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports